import React from 'react';
import { FormLabel, FormControl, FormErrorMessage } from '@hub/form';
import { Stack } from '@hub/stack';
import { Select } from '@hub/select';
import { ChevronDownSmallIcon } from '@hub/icon';
import { colors } from '@hub/design-system-base';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FormSelect = _ref => {
  let {
    name,
    id,
    label,
    placeholder,
    data,
    value,
    width = 'inherit',
    minHeight,
    isInvalid,
    autoComplete,
    errorMessage,
    isLoading = false,
    children,
    onChange,
    onBlur
  } = _ref;
  return /*#__PURE__*/_jsx(FormControl, {
    id: id,
    isInvalid: isInvalid,
    sx: {
      width
    },
    "data-id": "form_form-select_FormSelect_FormControl",
    children: /*#__PURE__*/_jsxs(Stack, {
      gap: "spacing-sm",
      "data-id": "form_form-select_FormSelect_FormControl_Stack",
      children: [label && /*#__PURE__*/_jsx(FormLabel, {
        htmlFor: id,
        sx: {
          color: isInvalid ? colors.error : ''
        },
        "data-id": "form_form-select_FormSelect_FormLabel",
        children: label
      }), /*#__PURE__*/_jsx(Select, {
        name: name,
        id: id,
        placeholder: placeholder,
        icon: /*#__PURE__*/_jsx(ChevronDownSmallIcon, {
          "data-id": "form_form-select_FormSelect_ChevronDownSmallIcon"
        }),
        isDisabled: isLoading,
        sx: {
          borderColor: isInvalid ? colors.error : colors.ghost,
          borderRadius: 'spacing-none',
          paddingLeft: 'spacing-md',
          width
        },
        value: value,
        autoComplete: autoComplete,
        minHeight: minHeight,
        onChange: onChange,
        onBlur: onBlur,
        "data-id": "form_form-select_FormSelect_Stack_Select",
        children: children || data.map((_ref2, key) => {
          let {
            value,
            label
          } = _ref2;
          return /*#__PURE__*/_jsx("option", {
            value: value,
            "data-id": "form_form-select_FormSelect_option",
            children: label
          }, key);
        })
      }), errorMessage && /*#__PURE__*/_jsx(FormErrorMessage, {
        sx: {
          color: colors.error,
          fontSize: 'font-sm'
        },
        "data-id": "form_form-select_FormSelect_FormErrorMessage",
        children: errorMessage
      })]
    })
  });
};
export default FormSelect;